import { useLocation } from 'react-router-dom';
import { useAppContext } from 'src/components/app-context';

export const useIsProduktjaktCampaign = () => {
  const { market } = useAppContext();
  const location = useLocation();
  const currentDate = new Date();
  const minDate = new Date('03/09/2023 GMT+01:00');
  const maxDate = new Date('03/17/2023 GMT+01:00');
  const produktjaktAllowedPath =
    location.pathname === '/' || location.pathname.includes('arets-produkt');
  return (
    currentDate > minDate &&
    currentDate < maxDate &&
    market.code === 'se' &&
    produktjaktAllowedPath
  );
};
